import React, { useEffect, useRef } from 'react'
import './Store_parselings.css'
import parselingsBookPng from '../../../assets/images/parselings/parselings-book.png'
import parselingsBookWebp from '../../../assets/images/parselings/parselings-book.webp'

const Store = () => {
  const contentRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (contentRef.current) observer.observe(contentRef.current);
    if (imageRef.current) observer.observe(imageRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section className="store-section">
      <div className="store-grid">
        <div className="content-column slide-from-left" ref={contentRef}>
          <h2>Get Parselings Now</h2>
          <div className="store-item">
            <h3>Core Rulebook</h3>
            <p>Experience the complete deck-building TTRPG with the digital edition of Parselings. Unleash adventure with a single purchase!</p>
            <a 
              href="https://www.drivethrurpg.com/en/product/293138/parselings-a-deckbuilding-ttrpg" 
              target="_blank" 
              rel="noopener noreferrer"
              className="store-button"
            >
              Purchase Now
            </a>
            {/* Additional CTA text */}
            <p className="cta-text">Don't miss out on the adventure – buy your copy today!</p>
          </div>
        </div>
        <div className="image-column slide-from-right" ref={imageRef}>
          <picture>
            <source srcSet={parselingsBookWebp} type="image/webp" />
            <img src={parselingsBookPng} alt="Parselings Book" className="store-image" />
          </picture>
        </div>
      </div>
    </section>
  )
}

export default Store